class custompdpcrosssell extends HTMLElement {
  constructor() {
    super();
    this.product_diteals = window.product_diteals;
    this.slider_conf = JSON.parse(this.dataset.sliderOptions);
    this.swiperel = this.querySelector('.swiper') || null;
    console.log("this.dataset",this.dataset)
     this.producti = parseInt(this.dataset.productId) || null;
    //  console.log(typeof this.product_diteals  , this.product_diteals.length)
    //  console.log("typeof this.product_diteals == 'object' && this.product_diteals.length > 0",typeof this.product_diteals == 'object' && this.product_diteals.length > 0)
    if( typeof this.product_diteals == 'object' && this.product_diteals.length > 0){
      // console.log(this.product_diteals,"this.product_diteals");
      window.initLazyScript(this, this.init.bind(this), 500);
    }else if(this.producti){
      this.closest(".custom_crosssell")?.classList.add("hidden");
      // console.log("this.producti",this.producti);
      // window.initLazyScript(this, this.relatedproduct.bind(this), 500);
    }
      // window.initLazyScript(this, this.relatedproduct.bind(this), 500);
  }

  async init() {
    try {

      const el = document.createElement('template');
            for (const item of this.product_diteals) {
            const response = await getProductInfo(item.handle); // likely HTML string
            // console.log("response",response);
           if(response) el.innerHTML += response.innerHTML;
            }
      if (el) {
        this.querySelector('.swiper-wrapper').innerHTML = el.innerHTML;
            if(this.swiperel && this.slider_conf){
                this.swiperobject = new Swiper(this.swiperel, this.slider_conf);
            }
            console.log("this.closest('.custom_crosssell').classList",this.closest('.custom_crosssell').classList)
            
      }else{
        this.closest('.custom_crosssell').classList.add('hidden');
      }

        setTimeout(() => {
          window.initLazyImages();
        }, 100);
    
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  }

  async relatedproduct() {
  try {
    const response = await fetch(
      `${window.Shopify.routes.root}recommendations/products.json?product_id=${this.producti}&limit=10&intent=related`
    );

    const { products } = await response.json();
    

    if (!products?.length) {
      this.closest(".custom_crosssell")?.classList.add("hidden");
      return;
    }

    const htmlList = await Promise.all(
      products.map(product => getProductInfo(product.handle))
    );

    const wrapper = this.querySelector(".swiper-wrapper");
console.log("url",`${window.Shopify.routes.root}recommendations/products.json?product_id=${this.producti}&limit=10&intent=related`);
    console.log("htmlList",htmlList);

    wrapper.innerHTML = htmlList
      .map(item => item instanceof HTMLElement ? item.innerHTML : item)
      .join("");

    if (this.swiperel && this.slider_conf) {
      this.swiperobject = new Swiper(this.swiperel, this.slider_conf);
    }

    window.initLazyImages?.();

    if(htmlList.length <= 0){
      this.closest(".custom_crosssell")?.classList.add("hidden");
    }

  } catch (error) {
    console.error(error);
    this.closest(".custom_crosssell")?.classList.add("hidden");
  }
}
}

customElements.define('custom-pdp-crosssell', custompdpcrosssell);


 async function getProductInfo(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=custompdpcrosssell`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
  
      const imageInfoEl = doc.querySelector('card-data') || null;  
      // console.log("handle",handle);
      if(imageInfoEl){
          return imageInfoEl;
      }else{
         return null;
      }

  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }